export default __webpack_public_path__ + "static/media/sb.24ea9a1f.jpeg";